var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.086,
    height: 6.615,
    viewBox: "0 0 16.086 6.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-link-4415012",
    d: "M90.657,175h2.631a.526.526,0,1,1,0,1.052H90.657a2.106,2.106,0,0,0-2.1,2.1v.007a2.106,2.106,0,0,0,2.1,2.1h2.631a.526.526,0,1,1,0,1.052H90.657a3.157,3.157,0,1,1,0-6.315Zm9.472,0H97.5a.526.526,0,0,0,0,1.052h2.631a2.106,2.106,0,0,1,2.1,2.1v.007a2.106,2.106,0,0,1-2.1,2.1H97.5a.526.526,0,0,0,0,1.052h2.631a3.157,3.157,0,1,0,0-6.315Zm-12.158,3.629a.138.138,0,0,1,.04.023.042.042,0,0,1,.015.032l-.055-.055Zm14.843,0a.138.138,0,0,0-.04.023.042.042,0,0,0-.015.032l.055-.055Zm-3.738-1H91.71a.526.526,0,0,0,0,1.052h7.367a.526.526,0,0,0,0-1.052Z",
    transform: "translate(-87.35 -174.85)",
    fill: "#181818",
    stroke: "#181818",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4b0e8e37.svg";
export { ForwardRef as ReactComponent };